import { useTranslation } from "react-i18next";
import moment from "moment";

const AdditionalInformation = ({
    authDetailBooking,
    typo12,
}) => {
    const { t, i18n } = useTranslation();

    const getMeetAssist = () => {
        if (authDetailBooking?.meetAssist[0].meetAssistName !== "none" || authDetailBooking?.meetAssist[1].meetAssistName !== "none") {
            let meetAssistText = "";
            if (authDetailBooking?.meetAssist[0].meetAssistName !== "none") {
                const text = t(`bookingDetail.additionalInformation.${authDetailBooking?.meetAssist[0].meetAssistName}.${authDetailBooking?.isFromAirport ? "airport" : "station"}.arrival`);
                meetAssistText += text;

                if (authDetailBooking?.meetAssist[1].meetAssistName !== "none") meetAssistText += `\n`
            }

            if (authDetailBooking?.meetAssist[1].meetAssistName !== "none") {
                const text = t(`bookingDetail.additionalInformation.${authDetailBooking?.meetAssist[1].meetAssistName}.${authDetailBooking?.isFromAirport ? "airport" : "station"}.departure`);
                meetAssistText += text;
            }

            return meetAssistText;
        }

        return false;
    }

    const getChildSeat = () => {
        if (authDetailBooking.totalChildSeatPrice > 0) {
            let addOnServices = "";
            const countInfant = authDetailBooking.bookingInfo.reduce((sum, booking) => sum + booking?.childSeat[0]?.childSeatCount, 0)
            const countToddler = authDetailBooking.bookingInfo.reduce((sum, booking) => sum + booking?.childSeat[1]?.childSeatCount, 0)
            const countChild = authDetailBooking.bookingInfo.reduce((sum, booking) => sum + booking?.childSeat[2]?.childSeatCount, 0)

            const text = `${t(`bookingDetail.additionalInformation.childSeat`)} (${countInfant > 0 ? `${t(`bookingDetail.additionalInformation.childSeatType.infant`, { count: countInfant })}` : ""}${(countInfant > 0 && (countToddler > 0 || countChild > 0)) ? ", " : ""}${countToddler > 0 ? `${t(`bookingDetail.additionalInformation.childSeatType.toddler`, { count: countToddler })}` : ""}${(countToddler > 0 && countChild > 0) ? ", " : ""}${countChild > 0 ? `${t(`bookingDetail.additionalInformation.childSeatType.child`, { count: countChild })}` : ""})`;
            addOnServices += text;

            return addOnServices;
        }

        return false;
    }

    const getMessage = () => {
        const result = authDetailBooking?.message?.find(
            (msg) => !msg?.isAdmin && msg?.note !== ""
        );

        return result?.note || false;
    }

    return (
        <div className="tw:rounded-[5px] tw:border tw:border-[#e8e8e8] tw:bg-white tw:lg:px-7 tw:py-[30px]">
            <div className="tw:font-hanken-grotesk tw:pb-6 tw:text-[15px] tw:font-bold tw:leading-[22px] tw:text-[#282828] tw:px-5 tw:lg:px-0">
                {t('bookingDetail.additionalInformation.title')}
            </div>
            <div className="tw:h-px tw:w-full tw:bg-[#e8e8e8]" />
            <div className="tw:flex tw:flex-col tw:gap-[14px] tw:pt-6 tw:px-5 tw:lg:px-0">
                {(authDetailBooking?.isFromAirport || authDetailBooking?.isFromStation) && (
                    <>
                        <div className="tw:flex tw:flex-wrap tw:gap-[54px]">
                            <div className="tw:flex tw:w-[200px] tw:flex-col tw:gap-[3px]">
                                <span className={`tw:font-hanken-grotesk tw:text-[#a7a7a7] ${typo12}`}>
                                    {t(`bookingDetail.additionalInformation.flightNumber.${authDetailBooking?.isFromAirport ? "airport" : "station"}.arrival`)}
                                </span>
                                {authDetailBooking?.pickupFlightNo ? (
                                    <p className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828]">
                                        {authDetailBooking?.pickupFlightNo}
                                    </p>
                                ) : (
                                    <em className="tw:font-hanken-grotesk tw:text-[15px] tw:italic tw:leading-[22px] tw:text-[#8d8d8d]">
                                        {t('bookingDetail.additionalInformation.none')}
                                    </em>
                                )}
                            </div>
                            {authDetailBooking?.pickupTerminal && (
                                <div className="tw:flex tw:w-[200px] tw:flex-col tw:gap-[3px]">
                                    <span className={`tw:font-hanken-grotesk tw:text-[#a7a7a7] ${typo12}`}>{t('bookingDetail.additionalInformation.terminal.pickup')}</span>
                                    <p className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828]">
                                        {t(`bookingDetail.additionalInformation.terminalItem.${authDetailBooking?.pickupTerminal}`)}
                                    </p>
                                </div>
                            )}
                            {authDetailBooking?.pickupSign && (
                                <div className="tw:flex tw:w-[200px] tw:flex-col tw:gap-[3px]">
                                    <span className={`tw:font-hanken-grotesk tw:text-[#a7a7a7] ${typo12}`}>
                                        {t(`bookingDetail.additionalInformation.pickupSign.${authDetailBooking?.isFromAirport ? "airport" : "station"}`)}
                                    </span>
                                    <p className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828]">
                                        {authDetailBooking?.pickupSignHonorific ? `${authDetailBooking?.pickupSignHonorific} ${authDetailBooking?.pickupSign}` : authDetailBooking?.pickupSign}
                                    </p>
                                </div>
                            )}
                        </div>
                        <div className="tw:h-px tw:w-full tw:bg-[#e8e8e8]" />
                    </>
                )}
                {(authDetailBooking?.isToAirport || authDetailBooking?.isToStation) && (
                    <>
                        <div className="tw:flex tw:flex-wrap tw:gap-[54px]">
                            <div className="tw:flex tw:w-[200px] tw:flex-col tw:gap-[3px]">
                                <span className={`tw:font-hanken-grotesk tw:text-[#a7a7a7] ${typo12}`}>
                                    {t(`bookingDetail.additionalInformation.flightNumber.${authDetailBooking?.isToAirport ? "airport" : "station"}.departure`)}
                                </span>
                                {authDetailBooking?.dropoffFlightNo ? (
                                    <p className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828]">
                                        {authDetailBooking?.dropoffFlightNo}
                                    </p>
                                ) : (
                                    <em className="tw:font-hanken-grotesk tw:text-[15px] tw:italic tw:leading-[22px] tw:text-[#8d8d8d]">
                                        {t(`bookingDetail.additionalInformation.none`)}
                                    </em>
                                )}
                            </div>
                            {authDetailBooking?.dropoffTerminal && (
                                <div className="tw:flex tw:w-[200px] tw:flex-col tw:gap-[3px]">
                                    <span className={`tw:font-hanken-grotesk tw:text-[#a7a7a7] ${typo12}`}>{t(`bookingDetail.additionalInformation.terminal.dropoff`)}</span>
                                    <p className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828]">
                                        {t(`bookingDetail.additionalInformation.terminalItem.${authDetailBooking?.dropoffTerminal}`)}
                                    </p>
                                </div>
                            )}
                        </div>
                        <div className="tw:h-px tw:w-full tw:bg-[#e8e8e8]" />
                    </>
                )}
                <div className="tw:flex tw:flex-wrap tw:gap-[54px]">
                    <div className="tw:flex tw:w-[200px] tw:flex-col tw:gap-[3px]">
                        <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] ${typo12}`}>
                            {t('bookingDetail.additionalInformation.meetAssistServiceTitle')}
                        </span>
                        {
                            getMeetAssist() ? (
                                <p className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828]">
                                    {getMeetAssist()}
                                </p>
                            ) : (
                                <em className="tw:font-hanken-grotesk tw:text-[15px] tw:italic tw:leading-[22px] tw:text-[#8d8d8d]">
                                    {t('bookingDetail.additionalInformation.none')}
                                </em>
                            )
                        }
                    </div>
                    <div className="tw:flex tw:w-[200px] tw:flex-col tw:gap-[3px]">
                        <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] ${typo12}`}>
                            {t('bookingDetail.additionalInformation.childSeat')}
                        </span>
                        {
                            getChildSeat() ? (
                                <p className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828]">
                                    {getChildSeat()}
                                </p>
                            ) : (
                                <em className="tw:font-hanken-grotesk tw:text-[15px] tw:italic tw:leading-[22px] tw:text-[#8d8d8d]">
                                    {t('bookingDetail.additionalInformation.none')}
                                </em>
                            )
                        }
                    </div>
                </div>
                <div className="tw:h-px tw:w-full tw:bg-[#e8e8e8]" />
                <div className="tw:flex tw:flex-wrap tw:gap-[54px]">
                    <div className="tw:flex tw:w-[200px] tw:flex-col tw:gap-[3px]">
                        <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] ${typo12}`}>{t('bookingDetail.additionalInformation.message')}</span>
                        {getMessage() ? (
                            <p className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828]">
                                {getMessage()}
                            </p>
                        ) : (
                            <em className="tw:font-hanken-grotesk tw:text-[15px] tw:italic tw:leading-[22px] tw:text-[#8d8d8d]">
                                {t('bookingDetail.additionalInformation.none')}
                            </em>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdditionalInformation;